import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import { getUserDetails, queryClient, QueryKeys } from '@investown/fe/api-sdk';

export function initSentry(): void {
  const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
  if (!sentryDsn || sentryDsn === '') {
    console.warn('Missing REACT_APP_SENTRY_DSN env variable');
    return;
  }

  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.REACT_APP_ENVIRONMENT,
    release: process.env.REACT_APP_COMMIT_SHA, // REACT_APP_COMMIT_SHA is set in CI during build
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,
  });
}

export async function setCurrentUser(): Promise<void> {
  // TODO: change to externalID
  const { intercomUserId } = await queryClient.fetchQuery(QueryKeys.UserDetails, getUserDetails);
  Sentry.setUser({ id: intercomUserId });
}

export function clearCurrentUser(): void {
  Sentry.configureScope((scope) => scope.setUser(null));
}

export function captureSentryError(error: Error | string): void {
  Sentry.captureException(error);
}
